import React from "react";
import DynamicLayout from "../components/DynamicLayout";
import LunarReturnExperience from "../components/tools/LunarReturnExperience";
import '../assets/ascendant-display.sass';

const LunarReturnPage = () => {
    return (
        <DynamicLayout>
            <LunarReturnExperience />
        </DynamicLayout>
    );
};

export default LunarReturnPage; 
